import configs from '../config';
import { fetchWithTenant } from '../utils/apiClient';

const API_URL = `${configs.BACKEND_URL}/api/upwork/mcp`;

async function handleResponse(response) {
  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    const error = new Error(data.message || `Request failed with status ${response.status}`);
    error.status = response.status;
    error.code = data.error;
    throw error;
  }
  return data;
}

export async function getUpworkMcpStatus() {
  const response = await fetchWithTenant(`${API_URL}/status`);
  return handleResponse(response);
}

export async function connectUpworkMcp(returnTo = '/admin/integrations') {
  const response = await fetchWithTenant(`${API_URL}/connect`, {
    method: 'POST',
    body: JSON.stringify({ returnTo }),
  });
  return handleResponse(response);
}

export async function disconnectUpworkMcp() {
  const response = await fetchWithTenant(`${API_URL}/disconnect`, { method: 'POST' });
  return handleResponse(response);
}

export async function setUpworkMcpDefaultAccount(orgUid) {
  const response = await fetchWithTenant(`${API_URL}/default-account`, {
    method: 'PUT',
    body: JSON.stringify({ orgUid }),
  });
  return handleResponse(response);
}

export async function getUpworkFeedStatus() {
  return handleResponse(await fetchWithTenant(`${API_URL}/jobs/status`));
}

export async function getUpworkRecommendedJobs(cursor, signal) {
  const query = new URLSearchParams({ mode: 'best_match', limit: '10' });
  if (cursor) query.set('cursor', cursor);
  return handleResponse(await fetchWithTenant(`${API_URL}/jobs/recommended?${query}`, { signal }));
}

export async function getUpworkJob(jobRef, signal) {
  return handleResponse(await fetchWithTenant(`${API_URL}/jobs/${encodeURIComponent(jobRef)}`, { signal }));
}

export async function importUpworkMcpProfile(orgUid) {
  return handleResponse(await fetchWithTenant(`${API_URL}/profile/import`, {
    method: 'POST', body: JSON.stringify({ orgUid }),
  }));
}
